import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Filters as NFTFilters } from '@pkg/types';

interface State {
    availableFilters?: NFTFilters;
    filteredResultsCount?: number;
    filterHidden?: 'hidden' | 'visible';
}
interface Actions {
    setFilterHidden: (newFilter: State['filterHidden']) => void;
    clearFilters: () => void;
    setAvailableFilters: (availableFilters: State['availableFilters']) => void;
    setFilteredResultsCount: (filteredResultsCount: State['filteredResultsCount']) => void;
}

type NFTsFiltersStoreState = Actions & State;

const initialState: State = {
    filteredResultsCount: undefined,
    availableFilters: undefined,
    filterHidden: undefined,
};

export const useNFTsFiltersStore = create<NFTsFiltersStoreState>()(
    devtools((set) => ({
        ...initialState,
        setFilterHidden: (newFilter) =>
            set((state) => {
                return { filterHidden: state.filterHidden && state.filterHidden === newFilter ? undefined : newFilter };
            }),
        setAvailableFilters: (availableFilters) => set({ availableFilters }),
        setFilteredResultsCount: (filteredResultsCount) => set({ filteredResultsCount }),
        clearFilters: () => set({ filterHidden: undefined }),
    })),
);
